/**
 * Logging Utility - Admin
 * 
 * Client-side logging utility for admin dashboard debugging and monitoring.
 * 
 * @version 1.0.0
 */

import config from './config';

const LOG_LEVELS = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
};

/**
 * Logger utility for Admin
 */
class Logger {
  constructor() {
    this.level = config.logging.level;
  }

  /**
   * Format log output
   * @private
   */
  formatLog(level, message, data = {}) {
    return `[${new Date().toISOString()}] [${level}] [ADMIN] ${message}`;
  }

  /**
   * Log error
   */
  error(message, data = {}) {
    console.error(this.formatLog(LOG_LEVELS.ERROR, message, data), data);
  }

  /**
   * Log warning
   */
  warn(message, data = {}) {
    if (config.isDevelopment) {
      console.warn(this.formatLog(LOG_LEVELS.WARN, message, data), data);
    }
  }

  /**
   * Log info
   */
  info(message, data = {}) {
    if (config.isDevelopment) {
      console.log(this.formatLog(LOG_LEVELS.INFO, message, data), data);
    }
  }

  /**
   * Log debug
   */
  debug(message, data = {}) {
    if (config.isDevelopment || config.logging.level === 'debug') {
      console.debug(this.formatLog(LOG_LEVELS.DEBUG, message, data), data);
    }
  }
}

export default new Logger();
